var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon32PxGoogle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 16.2955C29 15.3737 28.9156 14.4874 28.7588 13.6364H16.2653V18.6651H23.4045C23.0969 20.2901 22.1623 21.6669 20.7574 22.5887V25.8505H25.0445C27.5529 23.5874 29 20.2546 29 16.2955Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2653 29C19.847 29 22.8497 27.836 25.0445 25.8505L20.7574 22.5887C19.5696 23.3687 18.0501 23.8295 16.2653 23.8295C12.8103 23.8295 9.88591 21.5427 8.84277 18.47H4.41095V21.8382C6.5937 26.0868 11.0798 29 16.2653 29Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.84277 18.47C8.57747 17.69 8.42672 16.8569 8.42672 16.0001C8.42672 15.1433 8.57746 14.3101 8.84277 13.5301V10.1619H4.41095C3.51252 11.9169 3 13.9023 3 16.0001C3 18.0978 3.51253 20.0832 4.41095 21.8382L8.84277 18.47Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2653 8.17046C18.2129 8.17046 19.9615 8.82637 21.3363 10.1145L25.141 6.38591C22.8437 4.28818 19.8409 3 16.2653 3C11.0798 3 6.59369 5.91325 4.41095 10.1619L8.84277 13.5301C9.8859 10.4573 12.8103 8.17046 16.2653 8.17046Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon32PxGoogle);
export default __webpack_public_path__ + "static/media/icon_32px_google.a8ed791062ed801da97e68fdf4341e87.svg";
export { ForwardRef as ReactComponent };